module.exports = __webpack_public_path__ + "media/images/icons_apps_feature_sprite-67803b88.svg";